import * as React from 'react';
import {DatePicker} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import * as moment from 'moment';
import {MOMENT_DATE_TIME_FORMAT} from "../../utils/date-utils";
import {TimePickerProps} from "antd/es/time-picker";

export interface DisabledTimeHandler {
    disabledHours?: () => number[];
    disabledMinutes?: () => number[];
    disabledSeconds?: () => number[];
}

interface DatePickerFormItemProps extends BaseFormItemProps {
    showTime?: TimePickerProps | boolean;
    showClear?: boolean;
    format?: string | string[];
    onChange?: (date: moment.Moment, dateString: string) => void;
    disabledDate?: (current: moment.Moment | null) => boolean;
    disabledTime?: (current?: moment.Moment | null) => DisabledTimeHandler;
}

class DatePickerFormItem extends React.Component<DatePickerFormItemProps, {}> {

    public render(): React.ReactNode {
        const {disabled, showClear, showTime, format, disabledDate, disabledTime, onChange} = this.props;
        return (
            <BaseFormItem
                {...this.props}
                input={
                    <DatePicker
                        className="mild-disabled"
                        disabled={disabled}
                        showTime={showTime}
                        allowClear={showClear}
                        format={format || MOMENT_DATE_TIME_FORMAT}
                        disabledDate={disabledDate}
                        disabledTime={disabledTime}
                        onChange={onChange}
                    />}
            />
        );
    }
}

export default DatePickerFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/DatePickerFormItem.tsx